import { render } from "./SolucaoModalAtualizacao.vue?vue&type=template&id=f222010e&scoped=true"
import script from "./SolucaoModalAtualizacao.vue?vue&type=script&lang=js"
export * from "./SolucaoModalAtualizacao.vue?vue&type=script&lang=js"

import "./SolucaoModalAtualizacao.vue?vue&type=style&index=0&id=f222010e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f222010e"]])

export default __exports__